<template>
  <div>
      <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12 text-center mb-4">
              <h4 class="mb-0">
                Ya casí terminamos, por favor confirma la siguiente información
              </h4>
              <small>
                Es muy importante que tus datos sean correctos para poder ofrecerte un excelente servicio
              </small>
            </div>
          </div>
        <!-- Cuenta hispano  -->
        <div class="row">
            <div class="col-md-12">
            <h5 class="mb-0">
                Cuenta Hispano Club
            </h5>
            </div>
        </div>
        <div class="row align-items-center mb-4">
            <div class="col-md-8">
            <dl class="row mb-0">
                <dt class="col-sm-3"><span>Usuario</span></dt>
                <dd class="col-sm-9 mb-0">{{finalModel.email}}</dd>
            </dl>
            </div>
            <div class="col-md-4">
            <div :class="{'is-invalid': $v.user.password.$invalid, 'form-group': true}" style="margin: 0">
                <label for="password-input">{{$t('form.password')}}</label>
                <input type="text"
                class="form-control"
                v-model="user.password"
                @input="$v.user.password.$touch()"
                placeholder="">
                <div class="form-control-feedback" v-if="!$v.user.password.required">
                {{ $t('form.required') }}
                </div>
            </div>
            </div>
        </div>
        <!-- / Cuenta hispano  -->
        <!-- Producto -->
        <div class="row mb-4">
            <div class="col-md-8">
              <h5 class="mb-2">
                  Membresía Hispano Club {{itemdata.title}}
                  <!-- {{itemdata.subtitle}} -->
              </h5>
            </div>
            <div class="col-md-4 text-right">
              <h5>{{ itemdata.price | currency }} / {{itemdata.period}}</h5>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-md-8">
            <dl class="row mb-0" style=" font-size:  0.8rem; ">
                <dt class="col-sm-3"><span>Titular</span></dt>
                <dd class="col-sm-9 mb-0">{{finalModel.first_name}} {{finalModel.last_name}}</dd>
                <dt class="col-sm-3"><span>Email</span></dt>
                <dd class="col-sm-9 mb-0">{{finalModel.email}}</dd>
                <dt class="col-sm-3"><span>Cumpleaños</span></dt>
                <dd class="col-sm-9 mb-0">{{finalModel.birthdate}}</dd>
                <dt class="col-sm-3"><span>Celular</span></dt>
                <dd class="col-sm-9 mb-0">{{finalModel.mobile_phone}}</dd>
                <dt class="col-sm-3"><span>Dirección</span></dt>
                <dd class="col-sm-9 mb-0">{{finalModel.address_1}} {{finalModel.address_2}}</dd>
                <dt class="col-sm-3"><span>Ciudad</span></dt>
                <dd class="col-sm-9 mb-0">{{finalModel.city}}</dd>
                <dt class="col-sm-3"><span>Estado</span></dt>
                <dd class="col-sm-9 mb-0">{{finalModel.state}}</dd>
                <dt class="col-sm-3"><span>ZIP</span></dt>
                <dd class="col-sm-9 mb-0">{{finalModel.postcode}}</dd>
                <dt class="col-sm-3"><span>Socio</span></dt>
                <dd class="col-sm-9 mb-0">{{finalModel.seller_id}}</dd>
            </dl>
            </div>
        </div>
        <!-- / Producto -->
        <!-- Add Kit -->
        <div class="row mb-4">
            <div class="col-md-8">
            <h5 class="mb-2">
                Añadir Kit de Socio Hispano Club
                <!-- {{itemdata.subtitle}} -->
            </h5>
            </div>
            <div class="col-md-4">
            <div class="pull-right">
                <toggle-button v-model="buyKit"/>
            </div>
            </div>
        </div>
        <fade-transition>
        <div class="row" v-if="buyKit">
            <div class="col-md-8">
            <span>{{kitSocio.name}}</span>
            </div>
            <div class="col-md-4 text-right">
                + {{ kitSocio.cost | currency }}
            </div>
        </div>
        </fade-transition>
        <fade-transition>
        <div class="row align-items-center mb-2" v-if="buyKit">
          <div class="col-md-6">
            <div class="d-inline-block mr-4">
              ¿Deseas ingresar tu información fiscal?
            </div>
          </div>
          <div class="col-6">
            <div class="form-group m-0 d-inline-block pull-right">
              <div class="form-check form-check-inline ml-2">
                <label class="form-check-label">
                  <input class="form-check-input" type="radio" value="0"  v-model="addFiscal"> No
                </label>
              </div>
              <div class="form-check form-check-inline">
                <label class="form-check-label">
                  <input class="form-check-input" type="radio" value="1"  v-model="addFiscal"> Si, agregar ITIN
                </label>
              </div>
              <div class="form-check form-check-inline ">
                <label class="form-check-label">
                  <input class="form-check-input" type="radio" value="2"  v-model="addFiscal"> Si, agregar SSN
                </label>
              </div>
            </div>
          </div>
        </div>
        </fade-transition>
        <fade-transition>
        <div class="row align-items-center" v-if="(parseInt(addFiscal) === 1 || parseInt(addFiscal) === 2) && buyKit === true">
          <div class="col-md-6 text-right">
            <small>
              Ingresa tu &nbsp;
              <span v-if="parseInt(addFiscal) === 1">
                ITIN
              </span >
              <span v-else-if="parseInt(addFiscal) === 2">
                SSN
              </span>
            </small>
          </div>
          <div class="col-md-6">
            <div :class="{'is-invalid': $v.capturedFiscal.$invalid, 'form-group': true}" style="margin: 0" >
              <input type="text"
              class="form-control  form-control-sm"
              v-model="capturedFiscal"
              @input="$v.capturedFiscal.$touch()"
              placeholder="">
            </div>
          </div>
        </div>
        </fade-transition>
        <div class="row">
          <div class="col">
            <hr>
          </div>
        </div>
        <!-- / Add Kit -->
        <!-- Shipping -->
        <div class="row">
          <div class="col-md-4">
            <h5 class="mt-2 mb-2">
                <span>Costo de envio</span>
            </h5>
          </div>
          <div class="col-md-8 text-right">
            <h5>
              <span>
                + {{ computedShipping | currency }}
              </span>
            </h5>
          </div>
        </div>
        <!-- / Shipping -->
        <div class="row">
            <div class="col-sm-12">
            <hr>
            </div>
        </div>
        <!-- add cupón -->
        <div class="row">
            <div class="col-md-4">
              <h5 class="mt-2 mb-2">
                  ¿Tienes un cupón?
              </h5>
            </div>
            <div class="col-md-8">
              <fade-transition>
                <div class="container-fluid">
                  <div class="row">
                    <div class="col">
                      <div class="pull-right mt-2">
                          <toggle-button v-model="hasCoupon"/>
                      </div>
                    </div>
                  </div>
                  <div class="row align-items-center" v-if="hasCoupon">
                    <div class="col-md-4 text-right">
                      <label class="m-0 text-muted" for="coupon-input">{{$t('form.coupon')}}</label>
                    </div>
                    <div class="col-md-8">
                      <div :class="{'is-invalid': $v.user.coupon.$invalid, 'form-group': true}" style="margin: 0" >
                        <input type="text"
                        class="form-control  form-control-sm"
                        v-model="user.coupon"
                        @input="$v.user.coupon.$touch()"
                        placeholder="">
                      </div>
                    </div>
                  </div>
                </div>
              </fade-transition>
            </div>
        </div>
        <!-- / add cupón -->
        <div class="row">
            <div class="col-sm-12">
            <hr>
            </div>
        </div>
        <!-- total -->
        <div class="row mb-4">
            <div class="col-md-8">
            <h4 class="mb-2">
                Total a pagar
            </h4>
            </div>
            <div class="col-md-4 text-right">
            <h4>
              {{ computedTotal | currency }}
            </h4>
            </div>
        </div>
        <!-- / total -->
        <!-- terminos -->
        <div class="row">
            <div class="col-md-8">
              <small>
                  Autorizo cobro mensual por {{ itemdata.price | currency }} a mi tarjeta
              </small>
              <div class="text-danger" v-if="!$v.user.terms.recurrent.sameAs">
                <small>Debes aceptar el cargo mensual</small>
              </div>
            </div>
            <div class="col-md-4 text-right">
            <toggle-button v-model="user.terms.recurrent"/>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8">
              <small>
                  He leído y acepto la &nbsp;<a href="https://www.hispanoclub.com/legal/privacy-policy/" target="_blank">Política de Privacidad</a>
              </small>
              <div class="text-danger" v-if="!$v.user.terms.privacy.sameAs">
                <small>Debes aceptar la Política de Privacidad</small>
              </div>
            </div>
            <div class="col-md-4 text-right">
            <toggle-button v-model="user.terms.privacy"/>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-md-8">
              <small>
                  Acepto
                  <a href="https://www.hispanoclub.com/legal/terms-conditions-hispano-club-membership/" target="_blank">
                  Términos y Condiciones
                  </a> &nbsp;
                  de Membresía Hispano Club
              </small>
              <div class="text-danger" v-if="!$v.user.terms.terms.sameAs">
                <small>Debes aceptar los Términos y Condiciones</small>
              </div>
            </div>
            <div class="col-md-4 text-right">
              <toggle-button v-model="user.terms.terms"/>
            </div>
        </div>
        <!-- / terminos -->
        </div>
  </div>
</template>

<script>
// eslint-disable-next-line
import { validationMixin } from 'vuelidate'
// eslint-disable-next-line
import { required, minLength, maxLength, email, sameAs} from 'vuelidate/lib/validators'
export default {
  name: 'FormStepFour',
  props: [
    'finalModel',
    'itemdata'
  ],
  data () {
    return {
      step: 1,
      buyKit: false,
      addFiscal: 0,
      capturedFiscal: '',
      membership: {
        ship: 5
      },
      kitSocio: {
        name: 'Kit de Socio Hispano Club',
        cost: 55,
        ship: 15
      },
      hasCoupon: false,
      user: {
        username: '',
        password: '',
        coupon: '',
        SSN: '',
        ITIN: '',
        terms: {
          recurrent: false,
          privacy: false,
          terms: false
        }
      }
    }
  },
  validations () {
    if (parseInt(this.addFiscal) === 1) {
      return {
        capturedFiscal: {
          required
        },
        user: {
          username: {
            required
          },
          password: {
            required
          },
          coupon: {
          },
          ITIN: {
            required
          },
          terms: {
            recurrent: {
              required,
              sameAs: sameAs(() => true)
            },
            privacy: {
              required,
              sameAs: sameAs(() => true)
            },
            terms: {
              required,
              sameAs: sameAs(() => true)
            }
          }
        }
      }
    } else if (parseInt(this.addFiscal) === 2) {
      return {
        capturedFiscal: {
          required
        },
        user: {
          username: {
            required
          },
          password: {
            required
          },
          coupon: {
          },
          SSN: {
            required
          },
          terms: {
            recurrent: {
              required,
              sameAs: sameAs(() => true)
            },
            privacy: {
              required,
              sameAs: sameAs(() => true)
            },
            terms: {
              required,
              sameAs: sameAs(() => true)
            }
          }
        }
      }
    } else {
      return {
        user: {
          username: {
            required
          },
          password: {
            required
          },
          coupon: {
          },
          terms: {
            recurrent: {
              required,
              sameAs: sameAs(() => true)
            },
            privacy: {
              required,
              sameAs: sameAs(() => true)
            },
            terms: {
              required,
              sameAs: sameAs(() => true)
            }
          }
        }
      }
    }
  },
  computed: {
    isSelling () {
      return this.$store.state.isSelling.process
    },
    isSellingIndex () {
      return this.$store.state.isSelling.index
    },
    statusForm () {
      return this.$v.user.$invalid
    },
    computedUserName () {
      if (this.finalModel.first_name && this.finalModel.last_name && this.finalModel.birthdate) {
        let FirstName = this.finalModel.first_name.split(' ')
        let LastName = this.finalModel.last_name.split(' ')
        let BirthLastTwo = this.finalModel.birthdate.substring(2, 4)
        return this.$options.filters.lowercase(FirstName[0]) + this.$options.filters.lowercase(LastName[0]) + BirthLastTwo
      }
    },
    computedPassword () {
      if (this.finalModel.first_name && this.finalModel.last_name) {
        let FirstName = this.finalModel.first_name.split(' ')
        let LastName = this.finalModel.last_name.split(' ')
        return this.$options.filters.lowercase(LastName[0]) + this.$options.filters.lowercase(FirstName[0])
      }
    },
    computedTotal () {
      if (this.buyKit === true) {
        if (this.user.coupon === 'kit-free-shipping') {
          // Kit con cupon
          return this.kitSocio.cost + this.itemdata.price + this.computedShipping
        } else {
          return this.kitSocio.cost + this.itemdata.price + this.computedShipping
        }
      } else {
        return this.itemdata.price + this.computedShipping
      }
    },
    computedShipping () {
      if (this.buyKit === true) {
        if (this.user.coupon === 'kit-free-shipping') {
          return this.membership.ship
        } else {
          return this.kitSocio.ship
        }
      } else {
        return this.membership.ship
      }
    }
  },
  watch: {
    computedUserName  (value) {
      this.user.username = value
    },
    computedPassword  (value) {
      this.user.password = value
    },
    buyKit (value) {
      if (value === true) {
        this.user.add_kit = true
      } else {
        this.user.add_kit = false
      }
    },
    computedTotal (value) {
      if (this.buyKit === true) {
        if (this.user.coupon === 'kit-free-shipping') {
          // Kit con cupon
          this.user.price = this.kitSocio.cost + this.itemdata.price + this.computedShipping
        } else {
          // Kit sin cupon
          this.user.price = this.kitSocio.cost + this.itemdata.price + this.computedShipping
        }
      } else {
        // membresia sola
        this.user.price = this.itemdata.price + this.computedShipping
      }
    },
    addFiscal (value) {
      this.capturedFiscal = ''
    },
    capturedFiscal (value) {
      if (parseInt(this.addFiscal) === 1) {
        this.user.ITIN = value
      } else if (parseInt(this.addFiscal) === 2) {
        this.user.SSN = value
      } else {
      }
    },
    hasCoupon (value) {
      if (value === false) {
        this.user.coupon = ''
      }
    }
  },
  mounted () {
    this.user.price = this.itemdata.price
  },
  methods: {
    validate () {
      // console.log('validando')
      this.$v.user.$touch()
      var isValid = !this.$v.user.$invalid
      // console.log('es valido', isValid)
      this.$emit('on-validate', this.user, isValid)
      return isValid
    }
  }
}
/* {
  payment_token: 'tok_1Cm8XFG9eOPeXBTVIxjYNHIF',
  user: {
    username: 'test56ApiRest',
    password: 'Qwerty123'
  },
  data: {
    product_id: 406,
    payment_period: 'Mensual',

    first_name: 'Test56',
    last_name: 'ApiRest',
    email: 'test56apirest@yopmail.com',
    mobile_phone: '1234567890',
    birthdate: '1981-10-07',

    seller_id: 'socio-211',

    address_1: 'Test Avenue',
    address_2: '1200',
    city: 'Houston',
    state: 'TX',
    postcode: '77001',

    SSN: '234234234234',
    ITIN: '234234324234324'
  },
  add_kit: true
} */
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/FormStepFour.vue